<div class="item-container container-fluid p-0">
  <div class="row" (click)='onSelect()'>
    <div class="doc-repo col-3">
      <i class="icon {{fileIconType}}"></i>
    </div>
    <div class="doc-repo col-7">
      <div class="file-name">{{file.name}}</div>
      <div class="file-data">
        <span class='file-added mr-2'><strong>ADDED: </strong>{{file.createdTime | date : 'mediumDate' | uppercase}}</span>
        <span class='file-added'><strong>BY: </strong>{{file.author?.name | uppercase}}</span>
      </div>
    </div>
    <div class="col-2 row-controls">
      <a class="nav-link p-0" (click)="onDelete()">
        <span><i class="icon icon-trash" aria-hidden="true"></i></span>
      </a>
    </div>
  </div>
</div>
